export default {
  BASE_URL: '/admin/cms/content/advertisement',
  api: [
    /** 广告位管理 */
    {
      name: 'category',
      desc: '广告类目',
      method: 'GET',
      path: '/category'
    },
    {
      name: 'adListByCategory',
      desc: '广告列表',
      method: 'GET',
      path: '/adListByCategory/{id}'
    },
    {
      name: 'adDetail',
      desc: '广告详情',
      method: 'GET',
      path: '/adDetail/{id}'
    },
    {
      name: 'updateStatus',
      desc: '停用/启用',
      method: 'PUT',
      path: '/operate'
    },
    {
      name: 'addAd',
      desc: '添加/编辑',
      method: 'POST',
      path: '/operate'
    },
    {
      name: 'delAd',
      desc: '删除',
      method: 'DELETE',
      path: '/operate/{id}'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/cms/ad.js